<template>
  <div class="container boxShadow">
    <h5>非遗展厅预约</h5>
    <div class='cont'>
      <!-- <div class="legends">
        <span class="legend kyd">可预订</span>
        <span class="legend yyd">已预订</span>
      </div> -->
      <div class="table">
        <div class="row" v-for="item,index in list">
          <div>{{item.name}}</div>
          <div v-for="child in item.list">
            <div :class="child.status==0?'btn btn-default':'btn btn-primary'" @click="chooseItem(item.name,child)">{{child.start}} - {{child.end}}</div>
          </div>
        </div>

      </div>
    </div>

    <div class="mask" v-show="formFlag" @click.self="formFlag = false">
      <div class="container boxShadow">
        <h5>预约信息</h5>
        <div class="cont">
          <h6>您将预约 <span>{{form.date}}</span> 的{{form.start}} - {{form.end}}，该时间段已经预约<span>{{num}}</span>人</h6>
          <section>
            <div class="field">
              <p>姓名：<span>*</span></p>
              <input type="text" placeholder="请输入真实姓名" v-model="user.name">
            </div>
            <div class="field">
              <p>手机号：<span>*</span></p>
              <input type="number" placeholder="请输入您的手机号" v-model="user.phone">
            </div>
            <div class="field">
              <p>身份证号：<span>*</span></p>
              <input type="text" placeholder="请输入身份证号" v-model="user.idcard">
            </div>
            <div class="btn btn-primary" @click="submit">预约</div>
          </section>
        </div>
      </div>
    </div>

    <div class="user_center" @click="$router.push('/account')">
      个人中心
    </div>
  </div>
</template>

<script>
import customForm from '../components/form.vue'
export default {
  components: {
    customForm
  },
  inject: ['ajax'],
  data() {
    return {
      user: {},
      data: {},
      list: [],
      form: '',
      formFlag: false,
      user: {},
      num: ''
    };
  },
  computed: {
    dateFormat() {
      let arr = this.date.split('-')
      return `${arr[0]}年${arr[1]}月${arr[2]}日 - ${arr[3]}年${arr[4]}月${arr[5]}日`
    }
  },
  created() {

  },
  mounted() {
    let d = []
    for (let key in this.data) {
      d.push({
        name: key,
        list: this.data[key]
      })
    }
    this.list = d
    this.ajax('/api/feiyi/index', 'get', '', res => {
      console.log(res.data)
      let d = []
      for (let key in res.data.data) {
        d.push({
          name: key,
          list: res.data.data[key]
        })
      }
      this.list = d
    })
  },
  watch: {

  },
  methods: {
    chooseItem(date, item) {
      if (item.status == 0) {
        return
      }
      let obj = {
        date: date,
        start: item.start,
        end: item.end,
      }
      this.num = item.num
      this.form = obj
      this.ajax('/api/feiyi/getLastInfo', 'get', '', res => {
        console.log(res.data)
        if (res.data.data != false) {
          this.user = res.data.data
        }
      })
      this.formFlag = true
    },
    // 获取星期
    getWeek(date) {
      let d = new Date(date)
      let week = ['周日', '周一', '周二', '周三', '周四', '周五', '周六']
      return week[d.getDay()]
    },
    // 切换
    changeType(index, item) {
      if (this.activeType != index) {
        this.activeType = index
        let list = []
        for (let key in item.list) {
          list.push({
            date: key,
            list: item.list[key]
          })
        }
        this.currentlist = list
      }
    },
    submit() {
      let obj = { ...this.form, ...this.user }
      let param = this.$qs.stringify(obj)
      this.axios.post('/api/feiyi/create', param)
        .then(res => {
          console.log(res)
          if (res.data.errcode == 0) {
            window.location.reload()
          } else {
            this.$toast(res.data.errmsg)
            console.log(123)
          }
        })
    }
  },
  components: {
    customForm
  },
};
</script>

<style scoped>
.container {
  background: #fff;
  padding: 50px;
}

.container > h5 {
  font-size: 1.3em;
  color: #333333;
  text-align: center;
  padding-bottom: 20px;
  border-bottom: 1px solid #eeeeee;
}

.container > h5 > span {
  color: #999999;
  font-weight: normal;
}

.cont {
  padding: 20px 0;
}

.legends {
  text-align: center;
  color: #333;
  font-size: 1em;
  font-weight: bold;
}

.legend {
  font-style: italic;
  padding-left: 30px;
  position: relative;
  margin: 0 1em;
}

.legend::before {
  content: "";
  position: absolute;
  left: 0;
  top: 0;
  width: 1em;
  height: 1em;
  border-radius: 5px;
}

.kyd::before {
  background: #4ba6ff;
  border: 1px solid #4ba6ff;
}

.yyd::before {
  background: #eeeeee;
  border: 1px solid #dedede;
}

.tabbar {
  display: flex;
  padding: 30px 210px;
  justify-content: space-between;
}

.table {
  border-top: 1px solid #0677e4;
  padding: 5px 0;
}

.row {
  display: flex;
  color: #333;
  font-weight: bold;
  padding: 12px 0;
  align-items: center;
}
.row:nth-child(2n) {
  background: #f5f5f5;
}
.row > div {
  text-align: center;
  width: 33.3%;
}
@media only screen and (max-width: 750px) {
  .container > h5 {
    font-size: 1em;
    padding-bottom: 0.1rem;
  }
  .cont .item {
    width: 100%;
  }
  .container {
    padding: 0.2rem;
  }
  .legends {
    font-size: 0.13rem;
  }
  .tabbar {
    padding: 0.15rem 0;
  }
  .tabbar .btn {
    font-size: 0.12rem;
    width: 0.6rem;
  }
  .row {
    font-size: 0.12rem;
    flex-wrap: wrap;
  }
  .row .btn {
    width: 100%;
  }
  .row > div {
    margin-bottom: 0.1rem;
  }
}

.mask {
  width: 100%;
  height: 100vh;
  position: fixed;
  left: 0;
  top: 0;
  background-color: rgba(0, 0, 0, 0.5);
  z-index: 999999;
}

.mask .container {
  background: #fff;
  position: absolute;
  left: 50%;
  top: 50%;
  transform: translate(-50%, -50%);
}

.mask .container > h5 {
  font-size: 1.3em;
  color: #333333;
  text-align: center;
  padding-bottom: 20px;
  border-bottom: 1px solid #eeeeee;
}

.mask .cont {
  width: 36.3em;
  margin: 20px auto;
}

.mask .cont > h6 {
  font-size: 1em;
  color: #333;
  font-weight: bold;
  text-align: center;
}

.mask .cont > h6 > span {
  color: #0677e4;
  font-style: italic;
}

.mask .cont > section {
  padding: 30px 74px 0;
}

.mask .cont .btn {
  width: 100%;
  line-height: 45px;
  height: 45px;
}

.mask .field {
  min-height: 60px;
  padding: 5px 0;
}

.mask .field input[type="text"],
.mask .field input[type="number"] {
  font-size: 1em;
  border: 1px solid #cfcfcf;
  width: 100%;
  line-height: 45px;
  padding: 5px 10px;
  border-radius: 7px;
  height: 45px;
  outline: none;
  color: #a3a3a3;
}

.mask .field p {
  color: #666666;
  font-size: 0.9em;
  position: relative;
  margin-bottom: 5px;
}

.mask .field p > span {
  color: red;
}

.mask .field > label {
  font-size: 0.8em;
  color: #b2b2b2;
}

.mask .btn {
  margin-top: 15px;
}

.mask .blue {
  color: #42adff;
}

.mask .idcard {
  display: flex;
  justify-content: space-between;
  cursor: pointer;
}

.mask .idcard p {
  color: #999;
  width: 47%;
  height: 140px;
  border-radius: 7px;
  border: 1px solid #cfcfcf;
  color: #aaaaaa;
  text-align: center;
  line-height: 140px;
  font-size: 1.1em;
  overflow: hidden;
}

.mask .idcard p img {
  width: 100%;
  height: 100%;
  object-fit: cover;
}

.mask input[type="file"] {
  position: absolute;
  width: 100%;
  height: 100%;
  top: 0;
  left: 0;
  opacity: 0;
}

@media only screen and (max-width: 750px) {
  .mask .container {
    margin: 0 !important;
  }
  .mask .container > h5 {
    font-size: 1em;
    padding-bottom: 0.1rem;
  }

  .mask .cont .item {
    width: 100%;
  }

  .mask .container {
    padding: 0.15rem;
    font-size: 0.14rem;
  }

  .mask .cont {
    width: 100%;
  }

  .mask .cont > section {
    padding: 0 0.15rem;
  }

  .mask .field input[type="text"],
  .mask .field input[type="number"] {
    height: 0.35rem;
    line-height: 0.35rem;
  }

  .mask .idcard p {
    height: 0.8rem;
    line-height: 0.8em;
    overflow: hidden;
  }

  .mask .idcard p a {
    line-height: 0.8rem;
  }
}
</style>